import { useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';

/**
 * Korumalı route wrapper.
 * - Henüz session kontrol edilmediyse `/auth/me` çağrısı yapar.
 * - Login değilse `/giris`e yönlendirir.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { t } = useTranslation('components');
  const { user, hasCheckedSession, isLoading, fetchSession } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (!hasCheckedSession) {
      fetchSession();
    }
  }, [hasCheckedSession, fetchSession]);

  if (!hasCheckedSession || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-custel-bg">
        <p className="text-sm text-custel-text-secondary">{t('common:state.loading')}</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/giris" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
